import React 								from 'react';
import BLComponent							from '../../core/_BLComponent.jsx';
import CategoryModalFrame                   from './_CategoryModalFrame.jsx';

export default class CategoryTreeModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
	}

	render()
	{
        const categoryListView = this.getCategoryListView();
        const getCntSelectedCategory = this.getCntSelectedCategory();
        const footer = (getCntSelectedCategory == 0)?null: {sticky: true, buttons: [
            {text: 'Clear selection', onClickFunc: () => this.props.func.clearAllCategoryFilter(), type: 'default', classes: 'l-full-width'}
        // ,	{text: 'Save', onClickFunc: () => this.props.func.save(this.props.mode,this.state.series), classes: 'l-border--null bl-admin-btn bl-admin-btn--cta text--bold l-margin-left', align: 'right', disabled: this.state.loading == true}
        ]};

		return (
			<CategoryModalFrame footer={footer} classes="modal--medium personal-inventory__section-category-tree-modal" title="Filter by Category" closeFunc={() => this.props.func.toggleCategoryTreeModal()}>
				<ul>
                    {categoryListView}
                </ul>

			</CategoryModalFrame>
		)
	}

    getCategoryListView() {
        const {listCategory} = this.props.data;
        const categoryList = listCategory.map((category, idx) => {
            const catName = blapp.util.decodeHtml(category.catName);
            return(
                <li key={"categoryListModal-" + idx} onClick={()=>this.props.func.toggleCategory(category.idCategory, category.selected)} className={ "personal-inventory__section-category-tree-modal-item l-border--bottom " + ((category.selected)?"personal-inventory__section-category-tree-modal-item-selected":"")} >
                    <div className="l-flex l-split">
                        <div>{catName} ({category.itemCnt})</div>
                        {
                            category.selected && <div><i className="fa-solid fa-check text--bold personal-inventory__section-category-tree-list-item-selected-icon"/></div>
                        }
                    </div>
                </li>
            )
        });
        return categoryList;
    }

    getCntSelectedCategory() {
        let cntSelected = 0;
        const {listCategory} = this.props.data;
        for (const category of listCategory) {
            if (category.selected) cntSelected++;
        }
        return cntSelected;
    }
};


